
















































import { Component, Vue, Prop } from 'vue-property-decorator';
import moment from 'moment';
import { vxm } from '../../store.vuex';
@Component
export default class CandidateCard extends Vue {
  @Prop() candidate;
  @Prop({ default: false }) friendReferral;

  private statusTextMapping: any = {};
  getStatus(status) {
    return this.statusTextMapping[status] || '';
  }

  getReferredDate(date) {
    if (!date) {
      return '';
    }
    if (vxm.jobs.getCompanyDateFormat) {
      return moment(date).format(vxm.jobs.getCompanyDateFormat.toUpperCase());
    }
    return moment(date).format('DD-MMM-YYYY');
  }
  get canShowCall() {
    return false;
  }
  get canShowChat() {
    return false;
  }
  async fetchConversation(jobPostingId: number, referredUserId: number) {
    let cntxtType = '01';
    let cntxtId = jobPostingId;
    if (jobPostingId === null) {
      (cntxtType = '02'), (cntxtId = vxm.jobs.CompanyInfo.companyId);
    }
    try {
      let conversationResponse = await vxm.jobs.fetchExistingConversation({
        userId: vxm.users.myUserProfile.userId,
        contextType: cntxtType,
        contextId: cntxtId,
        conversationType: cntxtType,
        destination: referredUserId,
      });
      console.log('Response is : ', conversationResponse);
      if (conversationResponse.conversationGUID !== null) {
        vxm.jobs.setActiveConversationGUID(
          conversationResponse.conversationGUID,
        );
        console.log('value of guid is : ', vxm.jobs.ActiveConversationGUID);
      } else {
        try {
          let sendMessage = await vxm.jobs.sendMessage({
            isAdmin: false,
            originId: vxm.users.myUserProfile.userId,
            conversation: {
              conversationGUID: null,
              initiatedBy: vxm.users.myUserProfile.userId,
              claimedBy: vxm.users.myUserProfile.userId,
              participants: [referredUserId],
              context: cntxtType,
              contextId: cntxtId,
              companyCode: vxm.users.getCompanyCode,
            },
            conversationMessage: {
              origin: vxm.users.myUserProfile.userId,
              messageType: '01',
              messageText: '',
              destination: referredUserId,
            },
          });
          //set in store
          vxm.jobs.setActiveConversationGUID(sendMessage.conversationGUID);
        } catch (error) {
          var uri = window.origin + '/atsuser/chat';
          console.log('uri', uri);
          (window as any).location = uri;
        }
        this.$router.push({ name: 'Chat' });
      }
    } catch (error) {
      console.log(error, '--------------------------error');
    }
  }

  mounted() {
    this.statusTextMapping = {
      '90': this.$t('myreferrals.hired'),
      '50': this.$t('myreferrals.offered'),
      '10': this.$t('myreferrals.applied'),
      '00': this.$t('myreferrals.signedup'),
      '-10': this.$t('myreferrals.referred'),
    };
  }
}
